/* Carnis – pakkeside v2 (okt. 2026). Brukes av seksjonen «Carnis: Pakkekort v2» (carnis-pdp-pakke).
   1) Kjøpsvalg: månedsabonnement / engangskjøp, regnestykke, antall, vilkår ved knappen og kjøpslinje.
      Engangskjøp kan skrus av i seksjonen – da finnes bare abonnementet, og lenker som velger
      engangskjøp (data-cpdp-choose="once:…") velger abonnementet i stedet.
      [packs] i tekstene = pakker per forsendelse (antall × måneder per forsendelse),
      [min] = minstepris i bindingstiden (pris × antall × bindingsmåneder).
   2) Galleri.
   Handlekurven (talg + Organmix → pakken) ligger i carnis-pakke-kurv.js.
   Ingen avhengigheter utover temaets product-form.js. */
(function () {
  'use strict';

  function fmt(cents) {
    var v = Math.round(Number(cents) || 0);
    var kr = Math.floor(v / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0');
    var ore = ('0' + (v % 100)).slice(-2);
    return kr + ',' + ore + '\u00a0kr';
  }
  function fmtShort(cents) {
    var v = Math.round(Number(cents) || 0);
    if (v % 100 === 0) return Math.floor(v / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0') + '\u00a0kr';
    return fmt(v);
  }
  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function setText(root, sel, txt) { qsa(root, sel).forEach(function (el) { el.textContent = txt; }); }
  function tpl(str, map) {
    return String(str || '').replace(/\[(\w+)\]/g, function (m, k) { return map[k] !== undefined ? map[k] : m; });
  }
  function readJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /* ---------------- Galleri ---------------- */
  function initGallery(root) {
    var track = qs(root, '[data-cpk-track]');
    if (!track) return;
    var slides = qsa(track, '[data-cpk-slide]');
    if (!slides.length) return;
    var dots = qsa(root, '[data-cpk-dot]');
    var thumbs = qsa(root, '[data-cpk-thumb]');
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    function mark(i) {
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      track.dataset.index = i;
    }
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); }); });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { go(n); }); });
    var prev = qs(root, '[data-cpk-prev]'), next = qs(root, '[data-cpk-next]');
    if (prev) prev.addEventListener('click', function () { go((+track.dataset.index || 0) - 1); });
    if (next) next.addEventListener('click', function () { go((+track.dataset.index || 0) + 1); });
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { mark(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); });
    }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go((+track.dataset.index || 0) + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go((+track.dataset.index || 0) - 1); }
    });
    mark(0);
  }

  /* ---------------- Kjøpsvalg ---------------- */
  function initBuy(root) {
    var buy = qs(root, '[data-cpk-buy]');
    var cfg = readJSON(qs(root, '[data-cpk-config]'));
    if (!buy || !cfg) return;
    var t = cfg.text || {};
    var maxQty = Math.max(1, Number(cfg.maxQty) || 1);
    var shipMonths = Math.max(1, Number(cfg.shipMonths) || 1);
    var bindingMonths = Math.max(0, Number(cfg.bindingMonths) || 0);

    var form = qs(buy, 'form');
    var productForm = qs(buy, 'product-form');
    var inPlan = qs(buy, '[data-cpk-sp]');
    var inQty = qs(buy, '[data-cpk-qty]');
    var minus = qs(buy, '[data-cpk-minus]');
    var plus = qs(buy, '[data-cpk-plus]');
    var btn = qs(buy, '[data-cpk-atc]');
    var btnLabel = qs(buy, '[data-cpk-atc-label]');
    var modeInputs = qsa(buy, '[data-cpk-mode]');
    var opts = qsa(buy, '[data-cpdp-opt]');
    var note = qs(buy, '[data-cpk-unavailable]');
    var perks = qsa(buy, '[data-cpk-perks]');
    var hasSub = modeInputs.some(function (i) { return i.value === 'sub'; });
    var hasOnce = modeInputs.some(function (i) { return i.value === 'once'; });

    var state = { mode: (qs(buy, '[data-cpk-mode]:checked') || {}).value || (hasOnce ? 'once' : 'sub') };
    if (state.mode === 'sub' && !hasSub) state.mode = 'once';
    if (state.mode === 'once' && !hasOnce && hasSub) state.mode = 'sub';

    function qty() {
      var q = parseInt(inQty ? inQty.value : 1, 10);
      if (!q || q < 1) q = 1;
      if (q > maxQty) q = maxQty;
      return q;
    }

    function render() {
      var sub = state.mode === 'sub';
      var q = qty();
      if (inQty && String(inQty.value) !== String(q)) inQty.value = q;
      // Innholdslinjen under prisen: antall i hver levering ganges med valgt antall pakker
      qsa(root, '[data-cpk-n]').forEach(function (el) { el.textContent = String((Number(el.getAttribute('data-cpk-n')) || 0) * q); });
      buy.dataset.mode = state.mode;
      opts.forEach(function (o) { o.classList.toggle('is-active', o.getAttribute('data-cpdp-opt') === state.mode); });
      modeInputs.forEach(function (i) { i.checked = i.value === state.mode; });
      perks.forEach(function (el) { el.hidden = !sub; });

      // Regnestykket (per pakke)
      setText(buy, '[data-cpk-col]', sub ? t.colSub : t.colOnce);
      qsa(buy, '[data-cpk-cell]').forEach(function (el) {
        var v = Number(sub ? el.dataset.sub : el.dataset.once) || 0;
        el.textContent = fmtShort(v) + (sub && el.dataset.suffixSub ? el.dataset.suffixSub : '');
      });
      var saveEl = qs(buy, '[data-cpk-save]');
      if (saveEl) saveEl.textContent = tpl(sub ? t.saveSub : t.saveOnce, { save: fmtShort(Number(sub ? saveEl.dataset.sub : saveEl.dataset.once)) });

      // Pris for valgt antall, og pakker per forsendelse (abonnement)
      var unit = (sub ? Number(cfg.sub) : Number(cfg.base)) + (Number(cfg.packShip) || 0);
      var total = unit * q;
      var map = { price: fmtShort(total), packs: String(q * shipMonths), min: fmtShort(total * Math.max(1, bindingMonths)) };
      setText(buy, '[data-cpk-terms]', tpl(sub ? t.termsSub : t.termsOnce, map));
      if (btnLabel && btn && !btn.disabled) btnLabel.textContent = tpl(sub ? t.atcSub : t.atcOnce, map);
      setText(root, '[data-cpk-sticky-meta]', tpl(sub ? t.stickySub : t.stickyOnce, map));

      // Abonnement krever en ekte plan
      var blocked = sub && !cfg.subPlan;
      if (inPlan) { inPlan.value = cfg.subPlan || ''; inPlan.disabled = !(sub && cfg.subPlan); }
      if (btn) btn.toggleAttribute('data-cpk-blocked', blocked);
      if (note && !blocked) note.hidden = true;
      if (minus) minus.disabled = q <= 1;
      if (plus) plus.disabled = q >= maxQty;
    }

    modeInputs.forEach(function (i) {
      i.addEventListener('change', function () { if (i.checked) { state.mode = i.value; render(); } });
    });
    if (minus) minus.addEventListener('click', function () { inQty.value = qty() - 1; render(); });
    if (plus) plus.addEventListener('click', function () { inQty.value = qty() + 1; render(); });
    if (inQty) {
      inQty.addEventListener('change', render);
      inQty.addEventListener('input', function () { if (inQty.value !== '') render(); });
    }

    // Før temaets product-form sender skjemaet: sperr abonnement uten plan, og fjern app-injiserte selling_plan-felt
    if (productForm && form) {
      productForm.addEventListener('submit', function (e) {
        if (btn && btn.hasAttribute('data-cpk-blocked')) {
          e.preventDefault(); e.stopImmediatePropagation();
          if (note) { note.hidden = false; note.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
          return;
        }
        qsa(form, '[name="selling_plan"]').forEach(function (el) { if (el !== inPlan) el.parentNode.removeChild(el); });
        if (inPlan) inPlan.disabled = !(state.mode === 'sub' && cfg.subPlan);
        if (inQty) inQty.value = qty();
      }, true);
    }

    // Knapper i andre seksjoner: data-cpdp-choose="sub:…" / "once:…" (once bare når engangskjøp finnes)
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('[data-cpdp-choose]') : null;
      if (!a) return;
      var kind = (a.getAttribute('data-cpdp-choose') || '').split(':')[0];
      if (kind === 'sub' && hasSub) state.mode = 'sub';
      else if (kind === 'once' && hasOnce) state.mode = 'once';
      render();
      e.preventDefault();
      buy.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    render();
    initSticky(root, buy, form, btn);
  }

  /* ---------------- Kjøpslinje nederst ----------------
     Vises også før kunden har nådd knappen («Kjøp nå» tar kunden ned til knappen),
     og skjules mens selve knappen eller bunnteksten er synlig. */
  function initSticky(root, buy, form, btn) {
    var sticky = qs(root, '[data-cpk-sticky]');
    if (!sticky || !btn || !('IntersectionObserver' in window)) return;
    var footerSeen = false, atcSeen = true, atcAbove = false;
    function paint() {
      var show = !atcSeen && !footerSeen;
      sticky.classList.toggle('is-visible', show);
      sticky.classList.toggle('is-intro', !atcAbove);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { atcSeen = en.isIntersecting; atcAbove = en.boundingClientRect.top < 0; });
      paint();
    }, { threshold: 0 }).observe(btn);
    var footer = document.querySelector('footer, .footer, [id*="footer"]');
    if (footer) new IntersectionObserver(function (en) { footerSeen = en[0].isIntersecting; paint(); }).observe(footer);
    var sbtn = qs(sticky, '[data-cpk-sticky-btn]');
    if (sbtn) sbtn.addEventListener('click', function () {
      if (sticky.classList.contains('is-intro') || btn.hasAttribute('data-cpk-blocked')) { btn.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      if (form && typeof form.requestSubmit === 'function') form.requestSubmit(btn); else btn.click();
    });
    var change = qs(sticky, '[data-cpk-sticky-change]');
    if (change) change.addEventListener('click', function () { buy.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
  }

  function boot() {
    qsa(document, '[data-cpk-main]').forEach(function (root) {
      if (root.dataset.cpkReady) return;
      root.dataset.cpkReady = '1';
      initGallery(root);
      initBuy(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();